/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Graduationsecondtesttopic3Inputs */

const de__field_graduationsecondtesttopic3 = /** @type {(inputs: _Field_Graduationsecondtesttopic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweites Prüfungsthema Abschluss`)
};

/**

* @param {_Field_Graduationsecondtesttopic3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_graduationsecondtesttopic3 = /** @type {((inputs?: _Field_Graduationsecondtesttopic3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Graduationsecondtesttopic3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_graduationsecondtesttopic3(inputs)
});
export { _field_graduationsecondtesttopic3 as "_field_graduationSecondTestTopic" }